export function getSubscriptionPeriodSummary(periodEnd, now = Date.now()) {
    if (!periodEnd) return null;
    const end = new Date(periodEnd).getTime();
    if (!Number.isFinite(end)) return null;
    const remainingMs = end - Number(now);
    const expired = remainingMs <= 0;
    const totalHours = expired ? 0 : Math.ceil(remainingMs / 3600000);
    return {
        expired,
        remainingMs,
        days: Math.floor(totalHours / 24),
        hours: totalHours % 24,
    };
}

export function subscriptionPeriodSeverity(summary) {
    if (!summary) return "info";
    if (summary.expired) return "error";
    if (summary.days < 3 || (summary.days === 3 && summary.hours === 0)) return "warn";
    return "info";
}
